import { injectReducer } from '../../store/reducers'
import { getPatientDetail, getPatientHistory, clearState } from './modules/patientDetail'

export default (store) => ({
  path : '/doctor/:doctorId/patients/:patientId',
  childRoutes: [
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const PatientDetail = require('./containers/PatientDetailAdminContainer').default
      const reducer = require('./modules/patientDetail').default
      injectReducer(store, { key: 'patientDetail', reducer })
      var doctorId = nextState.params.doctorId
      var patientId = nextState.params.patientId
      store.dispatch(clearState())
      store.dispatch(getPatientDetail(patientId));
      cb(null, PatientDetail)
    }, 'patientDetailAdmin')
  }
})


// WEBPACK FOOTER //
// ./src/routes/PatientDetailAdmin/index.js